<div class="input-group input-group--tags">
  <label>
    {{ 'public-profile.identity.tags.label' | transloco }}
    ({{ selectedTags.length }}/{{ max }})
  </label>

  <input
    type="text"
    [formControl]="searchCtrl"
    placeholder="{{ 'public-profile.identity.tags.placeholder' | transloco }}"
    autocomplete="off"
    (focusin)="handleFocusIn()"
    (focusout)="handleFocusOut()"
    (blur)="handleBlur()"
    (keydown.enter)="handleEnter()"
    aria-autocomplete="list"
    aria-haspopup="listbox"
    [attr.aria-expanded]="tagsSuggestionsShown"
  />

  <!-- Tags Suggestions -->
  @if (tagsSuggestionsShown) {
    <ul class="autocomplete-suggestions" [class.autocomplete-suggestions--top]="position === 'top'" role="listbox">
      @if (filteredTags.length === 0) {
        <p>{{ 'public-profile.identity.tags.empty' | transloco }}</p>
      }
      @if (filteredTags.length > 0) {
        @for (tag of filteredTags; track tag) {
          <li role="option" (mousedown)="selectTag(tag)">
            <p>{{ ('marketplace.photographer.tags.' + tag.label) | transloco }}</p>
            <p>{{ tag.icon }}</p>
          </li>
        }
      }
    </ul>
  }
</div>

<!-- Selected Tags -->
<div class="selected-tags">
  @for (tag of selectedTags; track tag) {
    <div class="photographer-tag">
      <p>{{ ('marketplace.photographer.tags.' + tag) | transloco }}</p>
      <p>{{ getTagIconFromLabel(tag) }}</p>
      <button type="button" (click)="removeTag(tag)">×</button>
    </div>
  }
</div>
